import { Icon } from '..';

export const BlurbLogoIcon: Icon = ({ color = '#00aeef', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    {...props}
    aria-label="Blurb Icon"
  >
    <path
      d="M0 0h200v200H0z"
      style={{
        fill: 'none',
      }}
    />
    <path
      d="M75 156.2h125V0H75L0 37.5v156.3z"
      style={{
        fill: color,
      }}
    />
    <path
      d="M35.1 78.1v15.7c2.2-3.1 6-4.7 10.1-4.7 9.4 0 15.7 7.9 15.7 18.2 0 10.4-6.2 18.4-15.7 18.4-4.2 0-7.9-1.6-10.1-4.7v3.9H25V78.1h10.1zm7.7 39c5.1 0 7.5-4.3 7.5-9.6 0-5.2-2.4-9.7-7.5-9.7s-7.7 4.5-7.7 9.7c0 5.4 2.6 9.6 7.7 9.6zm21.8 7.9V78.1h10.1V125H64.6zm47.5-35v35h-10v-3.8c-2.1 2.8-5.8 4.6-10.1 4.6-7.4 0-11.6-5.5-11.6-12.5V90h10.1v20.9c0 3 1 6 5.1 6 3.7 0 6.5-2.4 6.5-7V90h10zm26.3 9.9c-.8-.3-1.8-.5-2.9-.5-4.1 0-7.5 3.1-7.5 10.2V125h-10V90h10.1v4.3c1.9-3.1 4.9-4.9 8.5-4.9 1 0 2.8.3 3.4.6l-1.6 9.9zm14.4-21.8v15.7c2.2-3.1 6-4.7 10.1-4.7 9.4 0 15.7 7.9 15.7 18.2 0 10.4-6.2 18.4-15.7 18.4-4.2 0-7.9-1.6-10.1-4.7v3.9h-10.1V78.1h10.1zm7.7 39c5.1 0 7.5-4.3 7.5-9.6 0-5.2-2.4-9.7-7.5-9.7s-7.7 4.5-7.7 9.7c0 5.4 2.6 9.6 7.7 9.6z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
);
